export enum ExamDifficultyLevels {
  academic = 0,
  easy = 10,
  normal = 20,
  hard = 30,
  tooHard = 40,
}
export enum ErrorReport {
  WRITING_MISTAKE = 1,
  SCIENTIFIC_MISTAKE = 2,
  UNCLEAR_ANSWER = 3,
  WRONG_CHOICE = 4,
  WRONG_TOPIC = 5,
  WRONG_DIFFICULTY_LEVEL = 6,
  REPETITIVE_QUESTION = 7,
  WITHOUT_QUALITY_QUESTION = 8,
}

export enum EnumRateType {
  UNKNOWN = -1,
  MONTA_MODULES = 1,
  PUBLISHER_MODULES = 2,
  HINT = 3,
  PLAN_CALENDAR = 4,
  QUESTION_ANSWER = 5,
}
